import { faCheck, faReceipt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { type PropsWithChildren } from "react";

import { T } from "@repo/transifex";
import { PrintButton } from "~/components/pos/print/print-button";

type PaymentSuccessProps = PropsWithChildren<{
  orderId: string;
}>;

export const PaymentSuccess = ({ orderId, children }: PaymentSuccessProps) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center">
      <div className="flex flex-col gap-y-40">
        <div className="flex flex-col items-center gap-y-8">
          <div className="flex flex-col items-center gap-y-3">
            <div className="flex size-16 items-center justify-center rounded-full bg-success-backdrop">
              <FontAwesomeIcon
                icon={faCheck}
                size="xl"
                className="text-success-dark"
              />
            </div>
            <p className="text-3xl text-success-dark">
              <T _str="Payment complete" />
            </p>
          </div>

          {children}

          <PrintButton orderId={orderId} icon={faReceipt} />
        </div>

        <p className="text-sm">
          <T _str="Tap or scan a product to start new order" />
        </p>
      </div>
    </div>
  );
};
